<template>
<div class="chapter">
<div class="inner_page">
<p class="PART_NUM"><a href="#/Text/33311_Contents#p1"><span class="blue">PART I</span></a></p>
<p class="PART_TTL"><a href="#/Text/33311_Contents#p1"><span class="blue">FROM<br/>
  THE CRADLE<br/>
  TO THE STAGE</span></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 33311_Part1.vue?19001075